import { render, staticRenderFns } from "./MDetailLock.vue?vue&type=template&id=22add2c5&scoped=true"
import script from "./MDetailLock.vue?vue&type=script&lang=js"
export * from "./MDetailLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22add2c5",
  null
  
)

export default component.exports